// Create new file: framework/client/helpers/payment/RazorpayClientHelper.js

import { PaymentClientHelperBase } from "../PaymentClientHelperBase.js";
import { ScriptLoader } from "../../core/ScriptLoader.js";

const RAZORPAY_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

export class RazorpayClientHelper extends PaymentClientHelperBase {
    
    async initiatePayment(orderData) {
        try {
            // 1. Dynamically load the Razorpay checkout script
            await ScriptLoader.load(RAZORPAY_SCRIPT_URL);

            // 2. Get user profile for pre-filling payment form
            const userProfile = await this.appClient.rpcClient.call('UserProfileRpc.getUserProfile');

            // 3. Configure the Razorpay options object
            const options = {
                key: orderData.razorpayKeyId,
                amount: orderData.amount,
                currency: orderData.currency,
                name: this.appClient.sessionTokenHandler.getClientConfig().appName || "Application",
                description: "Account Recharge",
                order_id: orderData.orderId,
                handler: async (response) => {
                    // This function is called by Razorpay upon successful payment
                    try {
                        await this.appClient.rpcClient.call('BillingRpc.verifyRechargePayment', {
                            gatewayName: 'razorpay',
                            paymentDetails: response
                        });
                        this.appClient.notifier.success("Recharge successful! Your balance has been updated.");
                        // Fire an event to notify other components (like BillingView) to refresh
                        this.appClient.events.local.emit('userBalanceUpdated');
                    } catch (verifyError) {
                        this.log.error("Razorpay payment verification failed:", verifyError);
                        this.appClient.notifier.error(`Payment verification failed: ${verifyError.message}`);
                    }
                },
                prefill: {
                    name: `${userProfile.firstName || ''} ${userProfile.lastName || ''}`.trim(),
                    email: userProfile.email,
                    contact: userProfile.phoneNumber || ''
                },
                theme: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--bs-primary').trim() || '#3399cc'
                }
            };

            // 4. Create a new Razorpay instance and open the checkout modal
            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (error) {
            this.log.error("Failed to initiate Razorpay payment:", error);
            this.appClient.notifier.error(`Could not start payment process: ${error.message}`);
        }
    }
}